// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"254":"cbd135bf661c8013","293":"727973242bb33abd"}[chunkId] + ".css";
};